function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import React from 'react';
import createReactContext from 'create-react-context';
import { cacheDateFormatter } from '../../formatters/DateTimeFormatter/makeDateFormatter';
import { cacheCurrencyFormatter } from '../../formatters/CurrencyFormatter/makeCurrencyFormatter';
var wixLocaleToBrowserLocale = {
  no: 'nb-NO'
};
export var PremiumLocaleContext = createReactContext({
  currencySettings: {},
  currencyCode: undefined
});
export var PremiumLocaleProvider = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PremiumLocaleProvider, _React$Component);
  function PremiumLocaleProvider(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var lng = _this.convertWixLocaleToBrowserLocal(props.lng);
    _this.state = {
      lng: lng,
      currencySettings: _this.props.currencySettings,
      currencyCode: _this.props.currencyCode,
      makeDateFormatter: cacheDateFormatter(lng),
      makeCurrencyFormatter: cacheCurrencyFormatter(lng)
    };
    return _this;
  }
  var _proto = PremiumLocaleProvider.prototype;
  _proto.convertWixLocaleToBrowserLocal = function convertWixLocaleToBrowserLocal(locale) {
    return wixLocaleToBrowserLocale[locale] || locale;
  };
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(PremiumLocaleContext.Provider, {
      value: this.state
    }, React.Children.only(this.props.children));
  };
  return PremiumLocaleProvider;
}(React.Component);